import { motion } from 'framer-motion';
import { useScrollSpy } from '../hooks/useScrollSpy';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import HeroSection from '../components/HeroSection';
import About from '../components/About';
import Experience from '../components/Experience';
import Skills from '../components/Skills';
import Education from '../components/Education';
import Certifications from '../components/Certifications';
import Specialties from '../components/Specialties';
import ScrollToTop from '../components/ScrollToTop';
import ChatBubble from '../components/ChatBubble';
import CursorSpotlight from '../components/CursorSpotlight';
import { resumeData } from '../data/resumeData';

const sectionIds = ['hero', 'about', 'experience', 'specialties', 'skills', 'education', 'certifications'];

function HomePage() {
  const activeSection = useScrollSpy(sectionIds);

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300 overflow-x-hidden">
      {/*
        Sprint 1 — B2: cursor "flashlight" overlay (dark-mode only,
        pointer:fine only, respects prefers-reduced-motion). Pointer-events:none
        and z:5, so it never intercepts clicks and sits above section
        backgrounds but below sticky chrome.

        Sprint 2 backlog (NOT implemented here, tracked for context):
          - A1  Test Coverage Field: verlet-physics canvas replacement for
                Hero ParticleBackground.
          - B1  Magnetic CTA buttons (cursor-tracking hover transforms).
          - B3  Vertical timeline component for Experience.
          - C1  Cmd+K palette (page-jump + section search).
      */}
      <CursorSpotlight />
      <Header data={resumeData} />
      <Navigation activeSection={activeSection} />
      
      <main className="lg:ml-64">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <HeroSection data={resumeData} />
          <About data={resumeData} />
          <Experience experiences={resumeData.experience} />
          <Specialties />
          <Skills skills={resumeData.skills} />
          <Education education={resumeData.education} />
          <Certifications certifications={resumeData.certifications} />
        </motion.div>
      </main>

      <ScrollToTop />
      <ChatBubble showAfterScroll={500} position="bottom-right" />
    </div>
  );
}

export default HomePage;
